import React from "react";
import { DEFAULT_APP_ROUTES } from "../../config/const";
import { Spinner } from "react-bootstrap";
import { Navigate } from "react-router-dom";

const DEFAULT_IFRAME_STYLE = {
  width: "100%",
  height: "100vh",
};

const AppIframe = ({
  iframeUrl = "",
  style = DEFAULT_IFRAME_STYLE,
  title = "",
  allowFullScreen = true,
  redirectUrl = DEFAULT_APP_ROUTES.PROTECTED,
  isRedirectionRequired = true,
}) => {
  return (
    <>
      {!Boolean(iframeUrl) ? (
        <div className="custom_placeholder_parent">
          <div className="custom_placeholder_child">
            <Spinner animation="grow" variant="primary" size="sm" />
            <Spinner animation="grow" variant="primary" size="sm" />
            <Spinner animation="grow" variant="primary" size="sm" />
          </div>
        </div>
      ) : iframeUrl === "notAllowed" ? (
        isRedirectionRequired && <Navigate to={redirectUrl} />
      ) : iframeUrl === "notFound" ? (
        isRedirectionRequired && <Navigate to={redirectUrl} />
      ) : (
        <div className="exchange_iframe">
          <iframe
            title={title}
            src={iframeUrl}
            frameBorder="0"
            style={style}
            // scrolling="no"
            allowFullScreen={allowFullScreen}
          >
            Your browser doesn't support iFrames.
          </iframe>
        </div>
      )}
    </>
  );
};
export default AppIframe;
